module.exports = __webpack_public_path__ + "static/media/mm_dive.1085374d.png";